<template>
  <div class="profile-view">
    <loading v-if="isProfileFetching" />
    <profile v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '@/app/components/Loading';
import Profile from '@/app/components/profile/Profile';

export default {
  name: 'ProfileView',
  components: {
    Loading,
    Profile
  },
  computed: {
    ...mapGetters('app', [
      'isProfileFetching'
    ])
  },
  async created() {
    await this.fetchProfile();
  },
  methods: {
    ...mapActions('app', [
      'fetchProfile'
    ])
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.profile-view {
  height: 100%;
  background-color: $av-solid-brand-lightest;
}
</style>
